module.exports = __webpack_public_path__ + "static/media/appointments.3230e726.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/app-composer/concierge/images/appointments.png
// module id = 270
// module chunks = 0